"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _css = _interopRequireDefault(require("./css.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var CssParser = /*#__PURE__*/function () {
  function CssParser() {
    _classCallCheck(this, CssParser);
  }

  _createClass(CssParser, [{
    key: "parse",
    value: function parse(cssHtml) {
      var cssJs = new _css.default();
      var parsed = cssJs.parseCSS(cssHtml);
      return parsed;
    } // This doesn't support nested css properties at this time (e.g. @media { ... })

  }, {
    key: "compose",
    value: function compose(cssJson) {
      var cssHtml = '';

      if (Array.isArray(cssJson)) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = cssJson[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var declaration = _step.value;
            cssHtml += declaration.selector + '{';
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = declaration.rules[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var rule = _step2.value;
                cssHtml += "".concat(rule.directive, ":").concat(rule.value, ";");
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            cssHtml += '}\n';
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else {
        console.info("Unable to compose css from input that is not an array of declarations.\n      Example:\n      [\n        {\n          \"selector\": \".my-class-name\",\n          \"rules\": [\n            {\n              \"directive\": \"color\",\n              \"value\": \"black\"\n            }\n          ]\n        },\n        {\n          \"selector\": \".my-important-class-name\",\n          \"rules\": [\n            {\n              \"directive\": \"color\",\n              \"value\": \"red\"\n            },\n            {\n              \"directive\": \"font-weight\",\n              \"value\": \"600\"\n            }\n          ]\n        }\n      ]\n\n      Given: ".concat(JSON.stringify(cssJson)));
      }

      return cssHtml;
    }
  }]);

  return CssParser;
}();

exports.default = CssParser;


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/core/CssParser/index.js